const getSessionUser = () => {
  const user = sessionStorage.getItem("userLogin");
  if (!user) {
    return null;
  }

  try {
    return JSON.parse(user);
  } catch (error) {
    return null;
  }
};

export default {
  computed: {
    $userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      }

      const currentUser = getSessionUser();
      return currentUser ? currentUser.role : null;
    },
    $currentUserData() {
      return getSessionUser();
    },
  },
};
